var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bars",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.61224H40.5C41.3285 6.61224 42 5.95442 42 5.14286V1.46939C42 0.657827 41.3285 0 40.5 0H1.5C0.671531 0 0 0.657827 0 1.46939V5.14286C0 5.95442 0.671531 6.61224 1.5 6.61224ZM1.5 21.3076H40.5C41.3285 21.3076 42 20.6497 42 19.8382V16.1647C42 15.3531 41.3285 14.6953 40.5 14.6953H1.5C0.671531 14.6953 0 15.3531 0 16.1647V19.8382C0 20.6497 0.671531 21.3076 1.5 21.3076ZM40.5 36.0029H1.5C0.671531 36.0029 0 35.345 0 34.5335V30.86C0 30.0485 0.671531 29.3906 1.5 29.3906H40.5C41.3285 29.3906 42 30.0485 42 30.86V34.5335C42 35.345 41.3285 36.0029 40.5 36.0029Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default ForwardRef;